import React, { useEffect, useState } from 'react';
import styles from '../css/modules/AnalogCounter.module.css';

// Ustawiamy wysokość pojedynczej cyfry zgodnie z nowymi wymiarami (25px)
const DIGIT_HEIGHT = 25;

const RollingDigit = ({ digit }) => {
  const [prevDigit, setPrevDigit] = useState(digit);
  const [currentDigit, setCurrentDigit] = useState(digit);

  useEffect(() => {
    if (digit === currentDigit) return undefined;

    setPrevDigit(currentDigit);
    const timer = setTimeout(() => {
      setCurrentDigit(digit);
    }, 10);
    /* Bez sprzątania licznik odmontowany w trakcie animacji (np. wyjście
       z pojedynku) próbował ustawić stan po odmontowaniu. */
    return () => clearTimeout(timer);
  }, [digit, currentDigit]);

  // Obliczenie przesunięcia, aby uzyskać efekt "rolling" w górę
  const getTranslateY = () => {
    if (prevDigit === currentDigit) {
      return currentDigit * DIGIT_HEIGHT;
    }
    return (10 + currentDigit) * DIGIT_HEIGHT;
  };

  return (
    <div className={styles.digitContainer}>
      <div
        className={styles.rollingContainer}
        style={{ transform: `translateY(-${getTranslateY()}px)` }}
      >
        {[...Array(20).keys()].map(num => (
          <div key={num} className={styles.digit}>
            {num % 10}
          </div>
        ))}
      </div>
    </div>
  );
};

const AnalogCounter = ({ value = 0, ariaLabel }) => {
  // Konwertujemy wartość na string i dzielimy ją na poszczególne cyfry.
  // Liczba pól będzie równa długości podanego inputu.
  const digits = value.toString().split('');

  return (
    <span className={styles.counterWrapper}>
      {/* Taśma cyfr to 20 divów z zerami i dziewiątkami na każdą pozycję -
          czytnik ekranu przeczytałby je wszystkie. Wartość podajemy obok
          zwykłym tekstem, ukrytym wizualnie. */}
      <span className={styles.counter} aria-hidden="true">
        {digits.map((digit, index) => (
          /* Klucz liczymy od KOŃCA, czyli od wagi cyfry (jedności, dziesiątki...).
             Przy indeksie od początku przejście 99 -> 100 przesuwało wszystkie
             cyfry o jedno pole i animacja przeskakiwała zamiast rolować. */
          <RollingDigit key={digits.length - index} digit={parseInt(digit, 10)} />
        ))}
      </span>
      <span className={styles.srOnly}>{ariaLabel || value}</span>
    </span>
  );
};

export default AnalogCounter;
